import React, { useState, useContext } from "react";
import Button from "@material-ui/core/Button";
import Select from "react-select";
import "../../../assets/css/milestone.css";
import edit from "../../../assets/images/edit.png";
import cross from "../../../assets/images/cross.png";
import makeStyles from "@material-ui/core/styles/makeStyles";
import MockTooltipComponent from "../MockTooltipComponent";
import Typography from "@material-ui/core/Typography";
import { userJourneyContext } from "../../../states/context/userJourneyContext";

const MockMilestoneSidebar = (props) => {
  const [value, setValue] = useState({ value: "Chen Lin", label: "Chen Lin" });
  const classes = useStyles();
  const userContext = useContext(userJourneyContext);

  const contactDetail = {
    company_name: "Taipei Textiles",
    person_name: "Chen Lin",
    role: "Logistics",
    email: "Chen.lin@Taipeitextiles.com",
    whatsapp: "(+94)(011)2449834"
  }

  const options = [
    { value: "Chen Lin", label: "Chen Lin" },
  ];
  return (
    <div>
      <MockTooltipComponent
        placement="bottom"
        open={userContext.userJourneyInfo.payload.steps === 15 ? !props.beforeEmail : false}
        popper={classes.getTrackingIDPopperTooltip}
        tooltipArrowStyle={classes.locationArrowStyle}
        title={
          <>
            <Typography className={classes.tooltipTitleStyle}>
              Click on Order Timeline
            </Typography>
            <p className={classes.tooltipTextStyle}>
              The Order Timeline provides further detail
            </p>
            <Typography className={classes.stepTextStyle}>
              (12/19)
            </Typography>
          </>
        }
        child={<div className="contactButton">
          <Button
            type="submit"
            className={classes.addNewContactButton}
          >
            + Add New Contact
          </Button>
        </div>
        }
      />
      <div style={{ width: "220px" }}>
        <Select
          options={options}
          placeholder="Select contact"
          id="contact_details"
          value={value}
        />
      </div>

      <div className="contactDetailRoot">
        {contactDetail.company_name !== '' && <>
          <div className='name'>
            {contactDetail.person_name}
            <div className="crossImgDiv">
              <img className="pointerStyle" src={cross} />
            </div>
          </div>
          <div className='companyLabel'>
            Company
          </div>
        </>}
        {contactDetail.role !== '' && <>
          <div className='companyName'>
            {contactDetail.company_name}
          </div>
          <div className='roleLabel'>
            Role
          </div>
          <div className='role'>
            {contactDetail.role}
          </div>
        </>}
        {contactDetail.email !== '' && <>
          <div className='emailLabel'>
            Email
          </div>
          <div className='email'>
            {contactDetail.email}
            <div className="edit-button"><img src={edit} /></div>
          </div>
        </>}
        {contactDetail.whatsapp !== '' && <>
          <div className='whatsAppLabel'>
            Whatsapp
          </div>
          <div className='whatsApp'>
            {contactDetail.whatsapp}
            <div className="edit-button" ><img src={edit} /></div>
          </div>
        </>}
      </div>
    </div>
  );
};

export default MockMilestoneSidebar;

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 0,
    margin: 0
  },
  getTrackingIDPopperTooltip: {
    zIndex: "1",
    marginLeft: "-40px",
    marginTop: "-116px"
  },
  tooltipTitleStyle: {
    marginTop: "0px",
    fontSize: "20px",
    fontFamily: "Inter",
    fontWeight: 600,
    marginBottom: "8px",
  },
  tooltipTextStyle: {
    marginTop: "0px",
    fontSize: "14px",
    fontFamily: "Inter",
    lineHeight: "20px",
    fontWeight: 400,
  },
  locationArrowStyle: {
    marginLeft: "-170px !important",
  },
  stepTextStyle: {
    padding: "0px",
    margin: "0px",
    fontSize: "14px",
    textAlign: "end",
    marginTop: "-10px",
    marginBottom: "-10px",
  },
  addNewContactButton:{
    color: "white",
    textTransform: "none", 
    height: "30px",
  }
}));